// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"checkbox_checkbox__ul_7n","disabled":"checkbox_disabled__e6mmJ","check":"checkbox_check__i_Luq","icon":"checkbox_icon__Pj_YQ","text":"checkbox_text__jWfup"};